import {Component, Input, OnInit} from '@angular/core';
import {getFuenteName} from '@services/negocios-service';

@Component({
  selector: 'app-negocios-fuente-icon',
  templateUrl: './negocios-fuente-icon.component.html',
  styleUrls: ['./negocios-fuente-icon.component.scss']
})
export class NegociosFuenteIconComponent implements OnInit {

  fuente = '';
  tooltip = '';

  @Input() size: 'big' | 'mid' | 'small' = 'big';

  @Input() set setFuente(id) {
    if (id) {
      switch (id.toString()) {
        case '1':
          this.fuente = 'laptop';
          break;
        case '2':
          this.fuente = 'phone_iphone';
          break;
        case '3':
          this.fuente = 'storage';
          break;
        default:
          this.fuente = 'help';
          break;
      }
      this.tooltip = getFuenteName(id);
    }
  };

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-fuente-icon/negocios-fuente-icon.component.ts